<template>
  <div>
    <m-groups
      :active="isGroupsModalActive"
      :modal-groups="modalGroups"
      @close="closeGroupsModal"
      @updatePostGroups="updatePostGroups"
    />

    <m-new-position :active="isNewPositionModalActive" @close="closeNewPositionModal" @saved="onCreateNewPosition" />

    <div class="layout positions">
      <div class="positions__stats">
        <template v-for="post in postsStats">
          <div v-if="post.countWorkers > 0" :key="post.name" class="positions__stats__post">
            <div class="positions__stats__post__title">{{ post.name }}</div>
            <div class="positions__stats__post__count">{{ post.countWorkers }}</div>
          </div>
        </template>
      </div>

      <div class="layout-header">
        <div class="layout-title">Должности</div>
        <div class="layout-header-actions">
          <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div>

          <div class="layout-header-action">
            <c-button
              :responsive="true"
              size="small"
              label="Настроить группы и категории"
              :icon="{ icon: 'groups', color: 'white' }"
              @click="isGroupsModalActive = true"
            />
          </div>

          <div class="layout-header-action layout-header-action-new-employee">
            <c-button-2
              size="small"
              label="Новая должность"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="isNewPositionModalActive = true"
            />
          </div>

          <div class="layout-header-action layout-header-action-new-employee-mobile">
            <c-button-2
              size="small"
              responsive
              label="Новая должность"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="isNewPositionModalActive = true"
            />
          </div>
        </div>
      </div>

      <div class="positions__fields" :class="{ positions__fields_active: filtersVisible }">
        <b-row align-v="center" cols="12">
          <b-col
            v-for="filter in globalFilters"
            :key="filter.name"
            sm="12"
            :md="filter.md"
            lg="auto"
            class="flex-grow-1"
          >
            <div class="positions__fields-item">
              <c-input
                v-if="filter.type === 'select'"
                v-model="filter.value"
                :type="filter.type"
                :label="filter.label"
                :checkbox="filter.checkbox"
                :checkbox-type="filter.checkboxType"
                :checkbox-tooltip="filter.checkboxTooltip"
                :checkbox-value="filter.checkboxValue"
                :multiple="filter.multiple"
                :searchable="filter.searchable"
                :placeholder="filter.placeholder"
                :items="filter.items"
                @checkboxChange="inputCheckboxChange"
              />

              <c-input
                v-if="filter.type === 'text'"
                v-model="filter.value"
                :type="filter.type"
                :label="filter.label"
                :placeholder="filter.placeholder"
                :clearable="filter.clearable"
              />

              <c-switcher v-if="filter.type === 'switcher'" v-model="filter.value" :label="filter.label" />
            </div>
          </b-col>

          <b-col col>
            <div class="positions__fields-actions">
              <div class="positions__fields-actions-item">
                <c-button
                  label="Сбросить"
                  :disabled="!$refs.routePositions || $refs.routePositions._data.isTableLoad"
                  @click="resetFilters"
                />
              </div>

              <div class="positions__fields-actions-item">
                <c-button
                  label="Применить"
                  color="primary"
                  :disabled="!$refs.routePositions || $refs.routePositions._data.isTableLoad"
                  @click="applyFilters"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="positions__tabs">
        <c-tabs
          :items="tabs"
          with-routing
          :current-query="$route.query"
          with-naming-routing="positions"
          naming-param="code"
        />
      </div>

      <div class="positions__content">
        <router-view
          ref="routePositions"
          :key="$route.params.code"
          :all-groups="modalGroups"
          :all-global-filters="globalFilters"
          :current-path-code="currentPathCode"
          :enabled-global-filters="enabledGlobalFilters"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Button from "@/components/controls2/Button";
import button from "@/components/controls/button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls/switcher";
import Tabs from "@/components/tabs";

import GroupsModal from "@/pages/positions/groups-modal";
import NewPositionModal from "@/pages/positions/new-position-modal/index";

export default {
  name: "positions",

  components: {
    "c-button": Button,
    "c-button-2": button,
    "c-input": Input,
    "c-switcher": Switcher,
    "c-tabs": Tabs,
    "m-groups": GroupsModal,
    "m-new-position": NewPositionModal,
  },

  data() {
    return {
      postsStats: [],
      bookmark: false,
      isGroupsModalActive: false,
      isNewPositionModalActive: false,
      modalGroups: [],
      tabs: [],
      currentPathCode: this.$route.params.code,
      filtersVisible: true,
      globalFilters: [
        {
          code: "filials_global",
          type: "select",
          label: "Изменения по филиалам",
          placeholder: "Все",
          searchable: true,
          clearable: true,
          multiple: true,
          checkbox: true,
          value: [],
          checkboxType: "icon",
          checkboxTooltip: {
            disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
            activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
            notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
          },
          checkboxValue: false,
          items: [],
          md: 12,
        },
        {
          code: "post_global",
          type: "text",
          placeholder: "Любая",
          label: "Должность",
          clearable: true,
          value: "",
          md: "auto",
        },
        {
          type: 'switcher',
          value: false,
          code: 'search[is_vacant]',
          label: 'Есть вакансии'
        }
      ],
      enabledGlobalFilters: [],
    };
  },
  computed: {
    ...mapGetters("positions", ["getPostGroups"]),
  },

  watch: {
    getPostGroups(value) {
      this.modalGroups = value.items;
      this.tabs = value.items.map((item) => ({ label: item.name, value: item.code }));
    },

    // "$route.params.code": function (value) {
    //   // this.resetFilters()
    // }
  },

  async created() {
    await this.$store.dispatch("positions/getPositionsStats").then((res) => {
      this.postsStats = res.items;
    });
    await this.$store.dispatch("positions/getPostGroups");
    await this.$store.dispatch("positions/getFilialReference").then((res) => {
      const c = this.globalFilters.findIndex((item) => item.code === "filials_global");

      if (c !== -1)
        this.globalFilters[c].items = res.items.map((filial) => ({
          id: filial.id,
          value: filial.id,
          label: filial.filial_name,
        }));

      this.setGlobalFiltersValues();
    });
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.applyFilters();
      }
    });
  },

  methods: {
    goToPositionsForm(positionCode) {
      this.$router.push({ name: "position-form", params: { positionCode } });
    },

    inputCheckboxChange(value, label) {
      const c = this.globalFilters.findIndex((item) => item.label === label);
      this.globalFilters[c].checkboxValue = value;
    },

    closeGroupsModal() {
      this.isGroupsModalActive = false;
      this.$refs.routePositions.updateTable();
    },

    updatePostGroups(groupCodeDeleted) {
      this.$store.dispatch("positions/getPostGroups").then(() => {});

      if (
        (groupCodeDeleted !== undefined || groupCodeDeleted !== null) &&
        this.$route.params.code === groupCodeDeleted
      ) {
        this.$route.params.code = this.tabs[0].value;
      }
    },

    closeNewPositionModal() {
      this.isNewPositionModalActive = false;
    },

    onCreateNewPosition(position) {
      this.goToPositionsForm(position.code);
    },

    applyFilters() {
      const enabledGlobalFilters = [];
      this.globalFilters.forEach((field) => {
        switch (field.type) {
          case "select": {
            let filterValue = [];
            if (Array.isArray(field.value)) {
              filterValue = field.value.map((i) => ({ id: i.id, label: i.label }));
            }
            if (field.value && field.value.value) {
              filterValue = [{ id: field.value.value }];
            }
            enabledGlobalFilters.push({
              id: field.code,
              searchType: field.checkboxValue,
              type: "list",
              value: filterValue,
            });
            break;
          }
          case "text":
            enabledGlobalFilters.push({
              id: field.code,
              searchType: "1",
              type: "string",
              value: field.value,
            });
            break;
          case "range":
            enabledGlobalFilters.push({
              id: field.code,
              searchType: "4",
              type: "number",
              value: {
                start: field.value[0],
                end: field.value[1],
              },
            });
            break;
          case "switcher":
            enabledGlobalFilters.push({
              id: field.code,
              type: "boolean",
              value: field.value ? "1" : "0",
            });
            break;
          default:
            break;
        }
      });

      this.enabledGlobalFilters = [...enabledGlobalFilters];
    },

    resetFilters() {
      this.globalFilters = this.globalFilters.map((item) => {
        if (item.type === "range") {
          item.value = [0, 0];
        } else if (Array.isArray(item.value)) {
          item.value = [];
          item.checkboxValue = false;
        } else if (typeof item.value === "boolean") {
          item.value = false;
        } else if (item.type === "text") {
          item.value = "";
        }
        return item;
      });

      this.applyFilters();
    },

    setGlobalFiltersValues() {
      this.globalFilters.forEach((field) => {
        if (this.$route.query[field.code] !== undefined) {
          if (this.$route.query[`${field.code}_filterType`] === "list") {
            const values = this.$route.query[field.code].split(",").map((item) => {
              const c = field.items.findIndex((i) => i.id.toString() === item.toString());

              if (c !== -1) {
                return { id: item, label: field.items[c].label, value: field.items[c].label };
              }
              return { id: item };
            });
            field.checkboxValue = this.$route.query[`${field.code}_searchType`] !== "1";
            field.value = values;
          } else {
            field.value = this.$route.query[field.code];
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-header-action-new-employee {
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.layout-header-action-new-employee-mobile {
  display: none;

  @media screen and (max-width: 700px) {
    display: block;
  }
}

.positions {
  padding: 54px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 1000px) {
    padding: 54px 30px 30px 30px;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &__stats {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 100%;
    display: flex;

    @media screen and (max-width: 700px) {
      display: none;
    }

    &__post {
      display: flex;
      align-items: center;
      padding: 0 5px;
      flex: 0 1 auto;

      &__title {
        font-size: 11px;
        overflow: hidden;
        width: calc(100% - 20px);
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &__count {
        margin-left: 5px;
        font-size: 11px;
        font-weight: 500;
      }
    }

    &__post:nth-child(1) {
      width: 29%;
      background: #cbe0ff;
      flex-grow: 6;
    }
    &__post:nth-child(2) {
      width: 21%;
      background: #cbf8e3;
      flex-grow: 5;
    }
    &__post:nth-child(3) {
      width: 12%;
      background: #fdffb3;
      flex-grow: 4;
    }
    &__post:nth-child(4) {
      width: 12%;
      background: #ffdfee;
      flex-grow: 4;
    }
    &__post:nth-child(5) {
      width: 11%;
      background: #e2d5ff;
      flex-grow: 3;
    }
    &__post:nth-child(6) {
      width: 8%;
      background: #c0fffc;
      flex-grow: 2;
    }
    &__post:nth-child(7) {
      width: 7%;
      background: #eff1f7;
      flex-grow: 1;
    }
  }

  &__fields {
    max-height: 0;
    overflow: hidden;
    transition: 0.3s;

    &_active {
      margin-bottom: 30px;
      max-height: none;
      overflow: visible;
    }

    &-item {
      margin-bottom: 30px;

      &-switcher {
        margin-top: 20px;
      }
    }

    &-actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      &-item {
        margin-left: 10px;

        @media screen and (max-width: 700px) {
          width: 50%;
        }

        @media screen and (max-width: 700px) {
          &:nth-child(1) .c-button,
          &:nth-child(2) .c-button {
            width: 95%;
          }
          &:nth-child(3) {
            display: flex;
            justify-content: flex-end;
          }
        }

        @media screen and (max-width: 700px) {
          &-hide-filters {
            display: none;
          }
        }

        &-hide-filters-mobile {
          display: none;
        }

        @media screen and (max-width: 700px) {
          &:nth-child(3) {
            margin: 0 auto;
          }

          &-hide-filters-mobile {
            margin: 0 auto !important;
            display: flex;
            justify-content: center;

            & .c-button {
              color: #0066ff;
              border: none;
            }
          }
        }
      }

      @media screen and (max-width: 700px) {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: -1rem;

        &-item {
          margin-left: 0;
          margin-bottom: 1rem;
        }
      }
    }

    &-show {
      opacity: 0;
      display: none !important;
      transition: 0.2s;

      &_active {
        opacity: 1;
        display: block !important;

        & > button {
          margin-bottom: 20px;
        }
      }

      @media screen and (max-width: 700px) {
        display: flex !important;
        justify-content: center;
      }

      @media screen and (max-width: 700px) {
        & .c-button {
          border: 0;
          color: #0066ff;
        }
      }
    }
  }

  &__tabs {
    margin-top: 30px;

    @media screen and (max-width: 700px) {
      margin-top: 0;
    }
  }

  &__content {
    margin-top: 22px;
  }
}
</style>
